'use strict';

module.exports = {
  adConfig: [{
    platforms: ['web', 'web-xlarge', 'web-xxlarge'],
    networkTimeout: 5,
    refreshRate: 30,
    formats: [{
      name: 'browse_side_dfp',
      medium: 'display',
      dimensions: [[300, 250], [300, 600]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.browse_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'browse_top_dfp',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.browse_top',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_side_dfp',
      medium: 'display',
      dimensions: [[300, 250], [300, 600]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.profile_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_top_dfp',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.profile_top',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'preroll',
      medium: 'audio',
      adUnitId: '15480783/Dev.Gemini/dev.preroll',
      cpm: 7,
      adProvider: 'dfp',
      reportRequest: true,
      reportError: true
    }, {
      name: 'banner_side_dfp_companion',
      medium: 'display',
      adProvider: 'dfp',
      dimensions: [[300, 250], [300, 600]],
      adUnitId: '/15480783/Dev.Gemini/dev.banner_side_companion',
      isCompanion: true
    }, {
      name: 'banner_top_dfp_companion',
      medium: 'display',
      adProvider: 'dfp',
      dimensions: [[728, 90]],
      adUnitId: '/15480783/Dev.Gemini/dev.banner_top_companion',
      isCompanion: true
    }, {
      name: 'banner_side_adswizz_companion',
      medium: 'display',
      adProvider: 'adswizz',
      dimensions: [[300, 250], [300, 600]],
      adUnitId: 'tunein.adswizz.com,625,626,631',
      isCompanion: true
    }, {
      name: 'banner_top_adswizz_companion',
      medium: 'display',
      adProvider: 'adswizz',
      dimensions: [[728, 90]],
      adUnitId: 'tunein.adswizz.com,625,626,631',
      isCompanion: true
    }, {
      name: 'truex_video',
      medium: 'video',
      adProvider: 'truex',
      reportRequest: true,
      reportError: true
    }, {
      name: 'view_model_ads',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/web_desktopweb/Display_Main_1',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }],
    slots: [{
      name: 'browse_side',
      formats: ['browse_side_dfp', 'banner_side_adswizz_companion', 'banner_side_dfp_companion']
    }, {
      name: 'browse_top',
      formats: ['browse_top_dfp', 'banner_top_adswizz_companion', 'banner_top_dfp_companion']
    }, {
      name: 'profile_side',
      formats: ['profile_side_dfp', 'banner_side_adswizz_companion', 'banner_side_dfp_companion']
    }, {
      name: 'profile_top',
      formats: ['profile_top_dfp', 'banner_top_adswizz_companion', 'banner_top_dfp_companion']
    }, {
      name: 'preroll',
      formats: ['preroll']
    }, {
      name: 'premium_unlock',
      formats: ['truex_video']
    }, {
      name: 'view_model_ads',
      formats: ['view_model_ads']
    }],
    webScreens: [{
      name: 'profile',
      slots: ['preroll', 'profile_side', 'profile_top', 'premium_unlock', 'view_model_ads']
    }, {
      name: 'search',
      slots: ['preroll', 'browse_side', 'premium_unlock', 'view_model_ads']
    }, {
      name: 'browse',
      slots: ['preroll', 'browse_top', 'browse_side', 'premium_unlock', 'view_model_ads']
    }, {
      name: 'default',
      slots: ['preroll', 'browse_side', 'browse_top', 'premium_unlock', 'view_model_ads']
    }]
  }, {
    platforms: ['web-medium', 'web-large'],
    networkTimeout: 5,
    refreshRate: 30,
    formats: [{
      name: 'browse_side_dfp',
      medium: 'display',
      dimensions: [[300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.browse_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'browse_top_dfp',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.browse_top',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_side_dfp',
      medium: 'display',
      dimensions: [[300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.profile_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_top_dfp',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.profile_top',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'preroll',
      medium: 'audio',
      adUnitId: '15480783/Dev.Gemini/dev.preroll',
      cpm: 7,
      adProvider: 'dfp',
      reportRequest: true,
      reportError: true
    }, {
      name: 'banner_side_dfp_companion',
      medium: 'display',
      adProvider: 'dfp',
      dimensions: [[300, 250]],
      adUnitId: '/15480783/Dev.Gemini/dev.banner_side_companion',
      isCompanion: true
    }, {
      name: 'banner_top_dfp_companion',
      medium: 'display',
      adProvider: 'dfp',
      dimensions: [[728, 90]],
      adUnitId: '/15480783/Dev.Gemini/dev.banner_top_companion',
      isCompanion: true
    }, {
      name: 'banner_side_adswizz_companion',
      medium: 'display',
      adProvider: 'adswizz',
      dimensions: [[300, 250]],
      adUnitId: 'tunein.adswizz.com,625,626,631',
      isCompanion: true
    }, {
      name: 'banner_top_adswizz_companion',
      medium: 'display',
      adProvider: 'adswizz',
      dimensions: [[728, 90]],
      adUnitId: 'tunein.adswizz.com,625,626,631',
      isCompanion: true
    }, {
      name: 'truex_video',
      medium: 'video',
      adProvider: 'truex',
      reportRequest: true,
      reportError: true
    }, {
      name: 'view_model_ads',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/web_desktopweb/Display_Main_1',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }],
    slots: [{
      name: 'browse_side',
      formats: ['browse_side_dfp', 'banner_side_adswizz_companion', 'banner_side_dfp_companion']
    }, {
      name: 'browse_top',
      formats: ['browse_top_dfp', 'banner_top_adswizz_companion', 'banner_top_dfp_companion']
    }, {
      name: 'profile_side',
      formats: ['profile_side_dfp', 'banner_side_adswizz_companion', 'banner_side_dfp_companion']
    }, {
      name: 'profile_top',
      formats: ['profile_top_dfp', 'banner_top_adswizz_companion', 'banner_top_dfp_companion']
    }, {
      name: 'preroll',
      formats: ['preroll']
    }, {
      name: 'premium_unlock',
      formats: ['truex_video']
    }, {
      name: 'view_model_ads',
      formats: ['view_model_ads']
    }],
    webScreens: [{
      name: 'profile',
      slots: ['preroll', 'profile_side', 'profile_top', 'premium_unlock', 'view_model_ads']
    }, {
      name: 'search',
      slots: ['preroll', 'browse_top', 'premium_unlock', 'view_model_ads']
    }, {
      name: 'browse',
      slots: ['preroll', 'browse_top', 'premium_unlock', 'view_model_ads']
    }, {
      name: 'default',
      slots: ['preroll', 'browse_top', 'premium_unlock', 'view_model_ads']
    }]
  }, {
    platforms: ['web-small'],
    networkTimeout: 5,
    refreshRate: 30,
    formats: [{
      name: 'browse_side_dfp',
      medium: 'display',
      dimensions: [[300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.browse_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'browse_mid_dfp',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.browse_top',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_side_dfp',
      medium: 'display',
      dimensions: [[300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.profile_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_top_dfp',
      medium: 'display',
      dimensions: [[728, 90]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.profile_top',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'preroll',
      medium: 'audio',
      adUnitId: '15480783/Dev.Gemini/dev.preroll',
      cpm: 7,
      adProvider: 'dfp',
      reportRequest: true,
      reportError: true
    }, {
      name: 'truex_video',
      medium: 'video',
      adProvider: 'truex',
      reportRequest: true,
      reportError: true
    }, {
      name: 'view_model_ads_mobile',
      medium: 'display',
      dimensions: [[320, 50], [300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/MOB_MobileWeb/Display_Main_1',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }],
    slots: [{
      name: 'browse_side',
      formats: []
    }, {
      name: 'browse_mid',
      formats: ['browse_mid_dfp']
    }, {
      name: 'profile_side',
      formats: []
    }, {
      name: 'profile_top',
      formats: ['profile_top_dfp']
    }, {
      name: 'preroll',
      formats: ['preroll']
    }, {
      name: 'premium_unlock',
      formats: ['truex_video']
    }, {
      name: 'view_model_ads_mobile',
      formats: ['view_model_ads_mobile']
    }],
    webScreens: [{
      name: 'profile',
      slots: ['preroll', 'profile_top', 'premium_unlock', 'view_model_ads_mobile']
    }, {
      name: 'search',
      slots: ['preroll', 'browse_mid', 'premium_unlock', 'view_model_ads_mobile']
    }, {
      name: 'browse',
      slots: ['preroll', 'browse_top', 'browse_mid', 'premium_unlock', 'view_model_ads_mobile']
    }, {
      name: 'default',
      slots: ['preroll', 'browse_mid', 'premium_unlock', 'view_model_ads_mobile']
    }]
  }, {
    platforms: ['web-min', 'web-xsmall'],
    networkTimeout: 5,
    refreshRate: 30,
    formats: [{
      name: 'browse_side_dfp',
      medium: 'display',
      dimensions: [[300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.browse_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_side_dfp',
      medium: 'display',
      dimensions: [[300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/Dev.Gemini/dev.profile_side',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }, {
      name: 'browse_mid_fallback',
      medium: 'display',
      dimensions: [[320, 50]],
      adProvider: 'fallback',
      adUnitId: 'browse_mid_fallback',
      cpm: 0,
      reportRequest: true,
      reportError: true
    }, {
      name: 'profile_mid_fallback',
      medium: 'display',
      dimensions: [[320, 50]],
      adProvider: 'fallback',
      adUnitId: 'profile_mid_fallback',
      cpm: 0,
      reportRequest: true,
      reportError: true
    }, {
      name: 'preroll',
      medium: 'audio',
      adUnitId: '15480783/Dev.Gemini/dev.preroll',
      cpm: 7,
      adProvider: 'dfp',
      reportRequest: true,
      reportError: true
    }, {
      name: 'truex_video',
      medium: 'video',
      adProvider: 'truex',
      reportRequest: true,
      reportError: true
    }, {
      name: 'view_model_ads_mobile',
      medium: 'display',
      dimensions: [[320, 50], [300, 250]],
      adProvider: 'dfp',
      adUnitId: '/15480783/MOB_MobileWeb/Display_Main_1',
      cpm: 2,
      reportRequest: true,
      reportError: true
    }],
    slots: [{
      name: 'browse_side',
      formats: []
    }, {
      name: 'browse_mid',
      formats: ['browse_mid_fallback']
    }, {
      name: 'profile_side',
      formats: []
    }, {
      name: 'profile_mid',
      formats: ['profile_mid_fallback']
    }, {
      name: 'preroll',
      formats: ['preroll']
    }, {
      name: 'premium_unlock',
      formats: ['truex_video']
    }, {
      name: 'view_model_ads_mobile',
      formats: ['view_model_ads_mobile']
    }],
    webScreens: [{
      name: 'profile',
      slots: ['preroll', 'profile_mid', 'premium_unlock', 'view_model_ads_mobile']
    }, {
      name: 'search',
      slots: ['preroll', 'browse_mid', 'premium_unlock', 'view_model_ads_mobile']
    }, {
      name: 'browse',
      slots: ['preroll', 'browse_mid', 'premium_unlock', 'view_model_ads_mobile']
    }, {
      name: 'default',
      slots: ['preroll', 'browse_mid', 'premium_unlock', 'view_model_ads_mobile']
    }]
  }]
};